import { SET_TO_DATE, SET_DATES } from '../../../../actions/chart';

export default (state = null, action) => {
  switch (action.type) {
    case SET_DATES:
      return action.payload.to;
    case SET_TO_DATE:
      return action.payload.value;
    default:
      return state;
  }
};

export const getToDate = state => state;